$(function() {
    let $currentTooltip = null;
    let land = $('.land');
    land.on('mouseenter', function(e) {
        // skryť predchádzajúci
        if ($currentTooltip) {
            $currentTooltip.removeClass('visible');
        }

        const id = $(this).data('id');
        const $tooltip = $('#land-' + id);

        if ($tooltip.length) {
            $tooltip.addClass('visible');
            $currentTooltip = $tooltip;
        }
    });

    land.on('mousemove', function(e) {
        if (!$currentTooltip) return;
        $currentTooltip.css({
            left: e.pageX + 'px',
            top: (e.pageY - 30) + 'px'
        });
    });

    land.on('mouseleave', function() {
        if ($currentTooltip) {
            $currentTooltip.removeClass('visible');
            $currentTooltip = null;
        }
    });
});
